import { gql } from "@apollo/client";

export const CREATE_PAYMENT_INTENT = gql`
  mutation CreatePaymentIntent($optionId: ID!) {
    createPaymentIntent(optionId: $optionId) {
      clientSecret
    }
  }
`;

export const VERIFY_PAYMENT = gql`
  mutation VerifyPayment($paymentIntentId: String!) {
    verifyPayment(paymentIntentId: $paymentIntentId)
  }
`;

export const GET_PURCHASE_HISTORY = gql`
  query GetPurchaseHistory {
    getPurchaseHistory {
      cost
      amount
      date
      description
      productType
      paymentIntentId
    }
  }
`;

export const GET_PURCHASE_RECEIPT = gql`
  query getPurchaseReceipt($paymentIntentId: String!) {
    getPurchaseReceipt(paymentIntentId: $paymentIntentId)
  }
`;

export const GET_PURCHASE_TOKENS_MENU = gql`
  query getPurchaseTokensMenu {
    getPurchaseTokensMenu {
      id
      amount
      cost
    }
  }
`;
